import { isIE } from '@utils'
import { LiveRoom } from '@services/api'

export const QINIU_STREAM_TYPE = {
  MAIN: 0, // 主流
  SAHRE: 1, // 分享流
  MIC: 2, // 连麦流
  MIX: 3, // 混流
}

export const QINIU_STREAM_STATUS = {
  START: 0, // 开始
  STOP: 1, // 结束
  REFRESH: 2, // 更新
}

export const SDK_PLATFORM = {
  PA_TECH: 2, // 科技(引用腾讯)
  QI_NIU: 3, // 七牛
}

const TYPE_STR = {
  0: 'main', // 主流
  1: 'share', // 分享流
  2: 'line', // 连麦流
}

export const formatQiniuStreams = (streamArr) => {
  const formatStreamArr = streamArr.map((stream) => {
    const { userId, streamId } = stream
    return {
      ...stream,
      uid: userId,
      sid: streamId,
      // sd: '@zn240p',
      // hd: '@zn480p',
      streamFrom: 'qiniu'
    }
  })
  return formatStreamArr
}
interface FORMA_URL {
  stream: any,
  roomId: string,
  playUrlPreObj: any
  definitionArr?: any[],
  quality?: number
}

// 获取清晰度后缀
const getQuality = (videoQualityList, videoQuality) => {
  const res = (videoQualityList || []).find((item) => item.value === videoQuality)
  return res?.quality ? `${res.quality}` : ''
}
// 处理播放地址
export const formatQNUrl = (params: FORMA_URL) => {
  const { stream, roomId, playUrlPreObj = {}, definitionArr = [], quality = 0 } = params
  const { hlsPlayUrl, hdlPlayUrl } = playUrlPreObj
  const videoQuality = getQuality(definitionArr, quality)
  // console.log('videoQuality ===>', videoQuality, quality)
  const { type, streamId } = stream
  const isIe = isIE()
  const pre = isIe ? hlsPlayUrl : hdlPlayUrl
  const exit = isIe ? 'm3u8' : 'flv'
  const url = `${pre.replace(/http:/, 'https:')}${roomId}_${streamId}_${type}${videoQuality}.${exit}`
  return url
}
// 处理清晰度选项
export const handleDefinitionArr = (qiniuRes) => {
  const { videoQualityList } = qiniuRes
  const definitionArr = (videoQualityList || []).map((item) => ({
    title: item.qualityName,
    value: item.videoQuality,
    quality: item.quality
  }))
  return definitionArr
}

// 最终得到的数据，处理播放数据结果
export const formdataVideoSourceQiniu = (
  stream: any,
  videoType: string,
  videoUserImg: string,
  videoUserName: string,
  _this
) => {
  const { hasVideo, hasAudio } = _this.getVideoConfig(stream, videoType)
  const isIe = isIE()
  let definitionArr: any = []
  let url = formatQNUrl({ stream, roomId: _this.liveRoomDetail.roomId, playUrlPreObj: _this.playUrlPreObj })
  const urlOriginal = url
  // 只有学堂直播且是主流才有清晰度切换
  if (videoType === 'main' && _this.liveRoomDetail.isSchoolLive) {
    // if (videoType === 'main') {
    definitionArr = _this.QNDefinitionArr.slice()
    url = formatQNUrl({
      stream,
      roomId: _this.liveRoomDetail.roomId,
      playUrlPreObj: _this.playUrlPreObj,
      definitionArr,
      quality: _this.currentDefinition
    })
  }
  // const urlOriginal = _this.getUrl(stream, definitionType.HIGH.value)
  const qiniuStream = {
    ...stream,
    url,
    urlOriginal,
    definitionArr,
    videoType,
    sourceType: isIe ? 'm3u8' : 'flv',
    videoUserImg,
    videoUserName,
    hasVideo,
    hasAudio,
  }
  console.log('qiniu stream========', qiniuStream)
  return qiniuStream
}

// 监听流信令变化
export const addQiniuStreamMsg = (data, _this) => {
  const { actionParam } = data
  console.log('qiniu-actionParam===', actionParam)
  const stream = formatQiniuStreams([actionParam])[0]
  // 有流开始
  if (+stream.eventType === QINIU_STREAM_STATUS.START) {
    // 如果没流说明是主播上麦了，需要开始上报学习时长
    if (_this.props.LiveStreamState!.liveDataSource.length === 0) {
      // 之前已经播放过则可以自动上报
      if (_this.state.playing) {
        _this.autoReportViewDuration()
        _this.props.LiveStreamState!.setNeedRestartReport()
      } else {
        _this.uploadReport()
      }
    }
    // 主播信息为空则当有新的流推送过来时直接请求详情接口重新拉流
    // eslint-disable-next-line max-len
    if (
      // 处理先进直播间还没有上麦没有请求拉流接口，拿不到播放地址的情况
      !_this.props.LiveStreamState!.playUrlPreObj!.hlsPlayUrl
      || (
        Object.keys(_this.props.LiveStreamState!.liveRoomDetail.anchors).length === 0
        && _this.props.LiveStreamState!.liveRoomDetail.anchors.length === 0
      )
    ) {
      _this.getLiveingInfo()
      return
    }
    _this.props.LiveStreamState!.addliveDataSoure([stream])
    return
  }
  // 有流结束
  if (+stream.eventType === QINIU_STREAM_STATUS.STOP) {
    _this.props.LiveStreamState!.deleteliveDataSoure(stream)
    // 如果只剩一个流了，说明主播下麦了
    if (_this.props.LiveStreamState!.liveDataSource.length === 0) {
      // 已经监听流减少时会上报，这里就不需要再次上报了 只需暂停上报
      _this.stopReport(false)
    }
    return
  }
}

// 主要用于处理接口返回的脏数据
export const filterStream = (streamArr) => {
  if (streamArr.length <= 1) return streamArr
  const arr: any = []
  const mainStreamArr = streamArr.filter((item) => item.type === QINIU_STREAM_TYPE.MAIN)
  const shareStreamArr = streamArr.filter((item) => item.type === QINIU_STREAM_TYPE.SAHRE)
  const lineStreamArr = streamArr.filter((item) => item.type === QINIU_STREAM_TYPE.MIC)
  if (mainStreamArr.length) {
    arr.push(mainStreamArr[mainStreamArr.length - 1])
  } else {
    // 没有主流就显示主播暂时不在，返回空
    return []
  }
  if (shareStreamArr.length) {
    arr.push(shareStreamArr[shareStreamArr.length - 1])
  }
  return [...arr, ...lineStreamArr]
}

// 已有异常数据删除
const filterLiveDataSource = (liveDataSource, stream) => {
  let tmpArr = liveDataSource.slice()
  tmpArr.some((item, index) => {
    // 只能有一个分享流，存在相同先删除
    if (item.type === QINIU_STREAM_TYPE.SAHRE && stream.type === QINIU_STREAM_TYPE.SAHRE) {
      tmpArr.splice(index, 1)
      return true
    }
    // 只能有一个主流，说明主播重新上麦，解决主播异常退出的场景，此时重置流信息
    if (item.type === QINIU_STREAM_TYPE.MAIN && stream.type === QINIU_STREAM_TYPE.MAIN) {
      tmpArr = []
      return true
    }
    // 如果存在相同类型且用户ID相同的流，则判定为异常退出没有正常销毁的流，需要先移除
    if (item.type === stream.type && item.uid === stream.uid) {
      tmpArr.splice(index, 1)
      return true
    }
    return false
  })
  return tmpArr
}

export async function addliveDataSoureQN(this: any, streamArr: any[] = []) {
  // 最多只能有一个主流和一个分享流，先筛选数据
  const source = filterStream(streamArr)
  for (const stream of source) {
    this.liveDataSource = filterLiveDataSource(this.liveDataSource, stream)
    if (this.liveDataSource.filter((data: any) => data.sid === stream.sid).length === 0) {
      const videoType = TYPE_STR[stream.type]
      // 防止多主播场景主播轮麦
      const anchor = this.liveRoomDetail.anchors.filter(
        (data: any) => data.userId === stream.uid
      )[0]
      // 防止多主播场景主播轮麦
      if (anchor && this.masterId !== anchor.userId) {
        this.masterId = anchor.userId
      }
      let userImg: any = ''
      let userName: any = ''
      if (videoType === 'line') {
        if (this.liveRoomDetail.micRaiseData && this.liveRoomDetail.micRaiseData.length > 0) {
          const micRaiseData = this.liveRoomDetail.micRaiseData.filter(item => item.userId === stream.uid)[0]
          if (micRaiseData) {
            userImg = micRaiseData.userPhoto
            userName = micRaiseData.userName
          } else {
            const res = await LiveRoom.getRaisehandList({
              roomId: this.liveRoomDetail.roomId
            })
            const aMicData = res.body.viewArr.map((item: any) => ({
              userId: item.userId,
              userName: item.userName,
              userPhoto: item.userPhoto
            }))
            this.updateRoomInfo(aMicData)
            const micRaiseData = aMicData.filter((item: any) => item.userId === stream.uid)[0]
            if (micRaiseData) {
              userImg = micRaiseData.userPhoto
              userName = micRaiseData.userName
            }
          }
        } else {
          const res = await LiveRoom.getRaisehandList({
            roomId: this.liveRoomDetail.roomId
          })
          const aMicData = res.body.viewArr.map((item: any) => ({
            userId: item.userId,
            userName: item.userName,
            userPhoto: item.userPhoto
          }))
          this.updateRoomInfo(aMicData)
          const micRaiseData = aMicData.filter((item: any) => item.userId === stream.uid)[0]
          if (micRaiseData) {
            userImg = micRaiseData.userPhoto
            userName = micRaiseData.userName
          }
        }
      }
      if (videoType === 'main') {
        userName = '主播'
        // 只跟新一条，且是主播流，说明主播重新上麦了，解决主播异常退出的场景
        if (source.length === 1) {
          this.liveDataSource = []
        }
      }
      if (videoType === 'share') {
        this.liveDataSource.unshift(
          formdataVideoSourceQiniu(stream, videoType, userImg, userName, this)
        )
      } else {
        this.liveDataSource.push(
          formdataVideoSourceQiniu(stream, videoType, userImg, userName, this)
        )
      }
    }
  }
  if (this.liveDataSource.length > 0) {
    this.isStepOut = false
  } else {
    this.isStepOut = true
  }
  console.log('liveDataSource=========', this.liveDataSource)
}
